import Badge from 'components/badge/Badge';
import styled from 'styled-components';

export const LeadMultiReservationLabelWrapper = styled(Badge).attrs({
  fontColor: '#3a84d8',
  backgroundColor: '#e7f1ff',
})`
  margin-left: 15px;
`;
